import { KeyValue } from '@/main/models/common';

export enum SupplierCategoryTypes {
  GET_SUPPLIER_CATEGORY = '@supplierCategory/GET_SUPPLIER_CATEGORY',
  SAVE_SUPPLIER_CATEGORY = '@supplierCategory/SAVE_SUPPLIER_CATEGORY',
  RESET_REDUCER_SUPPLIER_CATEGORY = '@supplierCategory/RESET_REDUCER_SUPPLIER_CATEGORY'
}

export interface SupplierCategoryState {
  readonly supplierCategory: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSupplierCategory {
  type: typeof SupplierCategoryTypes.GET_SUPPLIER_CATEGORY;
}

export interface SaveSupplierCategory {
  type: typeof SupplierCategoryTypes.SAVE_SUPPLIER_CATEGORY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSupplierCategory {
  type: typeof SupplierCategoryTypes.RESET_REDUCER_SUPPLIER_CATEGORY;
}

export type SupplierCategoryActionTypes =
  | GetSupplierCategory
  | SaveSupplierCategory
  | ResetReducerSupplierCategory;
